import React, { useEffect } from 'react';
import HomeVideo from '../Components/HomeVideo/HomeVideo';
import HomeInfo from '../Components/HomeInfo/HomeInfo';
import HomeFacilities from '../Components/HomeFacilities/HomeFacilities';
import HomeHouses from '../Components/HomeHouses/HomeHouses';
import HomeLocation from '../Components/HomeLocation/HomeLocation';
import Testimony from '../Components/Testimony/Testimony';

const Dashboard = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  });

  return (
    <>
      <HomeVideo />
      <HomeInfo />
      <HomeFacilities />
      <HomeHouses />
      <HomeLocation />
      <Testimony />
    </>
  );
};

export default Dashboard;
